import { Tooltip, IconButton } from "@mui/material";
import { semanticColors } from "../../utils/colors";

export default function ToolbarBtn({
  onClick,
  title,
  active,
  children
}: {
  onClick: () => void;
  title: string;
  active?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Tooltip title={title} placement="top">
      <IconButton
        size="small"
        onMouseDown={e => {
          e.preventDefault();
          onClick();
        }}
        sx={{
          width: 32,
          height: 32,
          borderRadius: "6px",
          color: active
            ? semanticColors.action.primary
            : semanticColors.text.primary,
          bgcolor: active
            ? `${semanticColors.action.primary}1A`
            : "transparent",
          "&:hover": {
            bgcolor: active
              ? `${semanticColors.action.primary}2E`
              : semanticColors.highlight.low
          }
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
